/**
 * 计算列数
 * @param {*} teamNum 队伍总数 
 */
export function calculateColNum(teamNum) {
  let num = 1;
  let dividend = teamNum || 1;
  while (dividend > 1) {
    dividend = dividend / 2;
    num++;
  }
  return num;
}

/**
 * 计算行数
 * @param {*} teamNum 队伍总数 
 */
export function calculateRowNum(teamNum) {
  // (teamNum / 2 - 1) 间隔数
  // (teamNum / 2 - 1) * 2 一个间隔有两个方格
  return (teamNum / 2 - 1) * 2 + teamNum;
}


/**
 * 创建数组
 * @param {*} len 
 * @returns 
 */
export function createArray(len) {
  const arr = [];
  let index = 0;
  for (let i = 0; i < len; i++) {
    arr.push(index++);
  }
  return arr;
}